var _rect, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurpSuite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7.1,
    width: 30.9,
    height: 30.9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "17.1,38.1 13.8,38.1 13.8,33.1 18.3,27.6 13.8,27.6 13.8,20.9 5.7,20.9 13.8,10.9 13.8,7.1 17.1,7.1   17.1,12.1 12.6,17.6 17.1,17.6 17.1,24.3 25.2,24.3 17.1,34.3 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurpSuite);
export default __webpack_public_path__ + "static/media/burp-suite.c0ce9a0d3682f4e35f9e719bcd3b4688.svg";
export { ForwardRef as ReactComponent };